import esFlag from '@images/flags/es.png'
export const useIdiomaStore = defineStore('idioma',() => {
  const idioma = ref({
    id: null,
    languaje: null,
    shortLang: null,
    flag: null,
    default: false,
  });

  const idiomas = ref([]);
  const locales = ref([{locale:'es',img:esFlag,name:"Españól"}]);

  const draft = computed(() => clone(idioma.value));


  const getIdiomaPorLocale = computed(() => (locale) => {
    let id = locales.value.find(v => v.locale === locale);
    if(id) return id.name;

    return locale;
  });

  const clear = () => {
    idioma.value = {
      id:null,
      languaje:null,
      shortLang:null,
      flag:null,
      default:false
    };
  };


  const setIdioma = (idiom) => {
    idioma.value = idiom
  };

  const setIdiomas = (idioms) => {
    idiomas.value  = idioms
  };

  const setLocales = (locals) => {
    locales.value = locals
  };

  const put = (idioma_id) => {
    if(idiomas.value.length){
      idiomas.value.splice(idiomas.value.findIndex(i => i.id === idioma_id),1);
    }
  };

  const updateLocale = (idioma) => {
      let i = locales.value.findIndex(v => v.locale === idioma.shortLang)

      if(i != -1){
        locales.value[i] = {
          locale:idioma.shortLang,
          img:`${axios.getUri()}/storage/flags/${idioma.flag}`,
          name:idioma.languaje
        }
      }
  };



  const pushLocale = (idioma) => {

    locales.value.push({
      locale:idioma.shortLang,
      img:`${axios.getUri()}/storage/flags/${idioma.flag}`,
      name:idioma.languaje
    })
  };

  const fetch = (idioma_id) => {
      return new Promise((resolve, reject) => {
        axios.get(`/api/idiomas/${idioma_id}/fetch-data`).then(({data}) => {
          setIdioma(data)
          resolve(data)
        }).catch(e  => reject(e))

      })
  };


  const fetchData = (filtro) => {
      return new Promise((resolve, reject) => {
        axios.post(`/api/idiomas/fetch-data`,filtro).then(({data})  => {
          setIdiomas(data.idiomas)
          resolve(data)
        }).catch(e => reject(e))
      })
  };

  const eliminar = (idioma_id) => {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/idiomas/${idioma_id}`).then(({data}) => {
          if(data.result){
            put(idioma_id)
          }
          resolve(data)
        }).catch(e => reject(e))
      })
  };

  const guardar = (datos) => {

    let formData = new FormData();

    Object.keys(datos).forEach(v => {
      formData.append(v,datos[v])
    }) 

    const headers = {
      headers:{
        ContentType:'multipart/form-data'
      }
    };


    return new Promise((resolve, reject) => {
      if(datos.id){
        formData.append('_method','PUT');
        axios.post(`/api/idiomas/${datos.id}`,formData,headers).then(({data}) => {
          updateLocale(data.idioma)
          resolve(data)
        }).catch(e => reject(e))
      }else{
        axios.post(`/api/idiomas`,formData,headers).then(({data}) => {
          pushLocale(data.idioma)
          resolve(data)
        }).catch(e => reject(e))
      }
    })
   };

   const cargarIdiomas = () => {
    return new Promise((resolve, reject) => {
      axios.get(`/api/idiomas/get-locales`).then(({data}) => {
        setLocales(data);
        resolve(data)
      }).catch(e => reject(e))
    })
   };

   const cargarIdiomaPorCliente = (cliente_id) => {
    return new Promise((resolve,reject) => {
      axios.get(`/api/idiomas/clientes/${cliente_id}/get-locales`).then(({data}) => {
          setLocales(data)
          resolve(data)
        }).catch(e => reject(e));

    })
   };

   const  fetchForShortLang = (lang) => {
    return new Promise((resolve, reject) => {
      axios.get(`/api/idiomas/fetch-for-short-lang/${lang}`).then(({data}) => {
        setIdioma(data.idioma)
        resolve(data)
      }).catch(e => reject(e))

    })
   };

   const guardarJson = ({idioma,json}) => {
    return new Promise((resolve, reject) => {
      axios.put(`/api/idiomas/${idioma}/change-json`,{json:json}).then(({data}) => resolve(data)).catch(e => reject(e))
    })
   };


   const fetchDataLight = () => {
    return new Promise((resolve, reject) => {
      axios.get(`/api/idiomas/fetch-data-light`).then(({data}) => resolve(data)).catch(e => reject(e))
    })
   };


  return {
    idioma,
    idiomas,
    locales,
    draft,
    getIdiomaPorLocale,
    clear,
    setIdioma,
    setIdiomas,
    setLocales,
    put,
    updateLocale,
    pushLocale,
    fetch,
    fetchData,
    eliminar,
    guardar,
    cargarIdiomas,
    cargarIdiomaPorCliente,
    fetchForShortLang,
    guardarJson,
    fetchDataLight
  };
});
export default useIdiomaStore;
